import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderInventoryDataSchema } from './ServicesProviderInventoryData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderInventory extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
        this.analyticsBoardUrl = data.analyticsBoardUrl;
        this.planDetails = data.planDetails;
        this.credits = data.credits;
        this.overflow = data.overflow;
        this.physicalAddress = data.physicalAddress;
    }
    validateData(data) {
        const result = servicesProviderInventoryDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderInventory.validation', `ServicesProviderInventory data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.INVENTORY,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.INVENTORY, ServicesProviderInventory);

export { ServicesProviderInventory };
//# sourceMappingURL=ServicesProviderInventory.js.map
